module.exports = __webpack_public_path__ + "static/Precy Cia-2fbefda630807e59749b427c364ba15b.png";